import React from "react";
import TeamCard from "./teamCard";
import { useTranslation } from "react-i18next";
import { Donator1, Donator2, Donator3, Donator4, Donator5, Donator6 } from "./data";
import { TeamContainer, TeamWrapper, TeamH1, TeamP } from "./teamElements";

const DonatorsSection = () => {
  const { t } = useTranslation();

  return (
    <TeamContainer id="team">
      <TeamH1> {t('donatorsTitle.txt')}</TeamH1>
      <TeamP> {t('donatorsP.txt')} &#9829;</TeamP>

      <TeamWrapper>
        <TeamCard {...Donator1} />
        <TeamCard {...Donator2} />
        <TeamCard {...Donator3} />
        <TeamCard {...Donator4} />
        <TeamCard {...Donator5} />
        <TeamCard {...Donator6} />
      </TeamWrapper>
    </TeamContainer>
  );
};

export default DonatorsSection;
